export const vocabularyConstants = {
  GETALL_REQUEST: 'VOCABULARY_GETALL_REQUEST',
  GETALL_SUCCESS: 'VOCABULARY_GETALL_SUCCESS',
  GETALL_FAILURE: 'VOCABULARY_GETALL_FAILURE',

  GET_STATS_REQUEST: 'VOCABULARY_GET_STATS_REQUEST',
  GET_STATS_SUCCESS: 'VOCABULARY_GET_STATS_SUCCESS',
  GET_STATS_FAILURE: 'VOCABULARY_GET_STATS_FAILURE',

  CREATE_REQUEST: 'VOCABULARY_CREATE_REQUEST',
  CREATE_SUCCESS: 'VOCABULARY_CREATE_SUCCESS',
  CREATE_FAILURE: 'VOCABULARY_CREATE_FAILURE',

  UPDATE_REQUEST: 'VOCABULARY_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'VOCABULARY_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'VOCABULARY_UPDATE_FAILURE',

  DELETE_REQUEST: 'VOCABULARY_DELETE_REQUEST',
  DELETE_SUCCESS: 'VOCABULARY_DELETE_SUCCESS',
  DELETE_FAILURE: 'VOCABULARY_DELETE_FAILURE',

  SEARCH_REQUEST: 'VOCABULARY_SEARCH_REQUEST',
  SEARCH_SUCCESS: 'VOCABULARY_SEARCH_SUCCESS',
  SEARCH_FAILURE: 'VOCABULARY_SEARCH_FAILURE',
};
